module.exports = __webpack_public_path__ + "static/media/house-2.3b571bc1.jpeg";